import { Currency } from "@evennt-tech/api-v2-core";
import { currenciesAreNotMaintainBankTransfer } from "constraints/general";
import RawOrder from "ts/api/order";

export const isBankTransferCurrency = (currency: Currency): boolean =>
  !currenciesAreNotMaintainBankTransfer.includes(currency);

// A supplier's per-order override applies to Quick Orders only.
export const isBankTransferAllowedByOrder = (
  order?: Pick<RawOrder, "isQuick" | "allowBankTransfer"> | null
): boolean => order?.isQuick === true && order?.allowBankTransfer === true;

type IsBankTransferAvailableParams = {
  currency: Currency;
  enableBankTransferPaymentMethod?: boolean | null;
  bankTransferMinimalOrderValue?: number | null;
  totalAmount: number;
  isAllowedByOrder?: boolean;
};

// The currency is a hard gate: no order-level override can lift it.
const isBankTransferAvailable = ({
  currency,
  enableBankTransferPaymentMethod,
  bankTransferMinimalOrderValue,
  totalAmount,
  isAllowedByOrder,
}: IsBankTransferAvailableParams): boolean => {
  if (!isBankTransferCurrency(currency)) {
    return false;
  }
  if (isAllowedByOrder) {
    return true;
  }
  if (enableBankTransferPaymentMethod === false) {
    return false;
  }
  return totalAmount >= (bankTransferMinimalOrderValue || 0);
};

export default isBankTransferAvailable;
